module.exports = __webpack_public_path__ + "static/media/Mobile_Carrosel_INTERNET_OF_THING_E_SENSORIZACAO (1).a74c492e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/courses/InternetOfThings/Mobile_Carrosel_INTERNET_OF_THING_E_SENSORIZACAO (1).png
// module id = 64
// module chunks = 0